import React, { useContext, useEffect, useState } from "react";
import classnames from "classnames";
import { Popover, PopoverAnchor, PopoverContent } from ".";
import GlobalSketchPicker from "./globalsketchpicker";
import ResetState from "./resetstate";
import { GrigoraEditorContext } from "../editor/context";

function ColorInput({
  value,
  onChange,
  palette = [],
  label = "",
  className,
  resetValue,
  isResetVisible = true,
  isResponsive = false,
  valueTablet,
  setValueTablet,
  resetValueTablet,
  valueMobile,
  setValueMobile,
  resetValueMobile,
  contentClassName,
  zIndex,
  selectProps = {},
}) {
  const [openPopOver, setOpenPopOver] = useState(false);
  const [active, setActive] = useState("desktop");

  const editorContext = useContext(GrigoraEditorContext);

  useEffect(() => {
    if (editorContext?.displaySize && isResponsive) {
      setActive(editorContext.displaySize);
    }
  }, [editorContext?.displaySize]);

  if (value === undefined || value === null) {
    value = "";
  }

  const classes = classnames(
    "grigora-color-input text-grigora-base border-[1px] rounded-[6px] flex items-center select-none bg-editor-input-selected  my-2",
    className,
  );

  const contentClasses = classnames(
    "!bg-editor-light-main !z-[1000] !shadow-editor-floating-elements !rounded-[10px]",
    contentClassName,
  );

  return (
    <div className={classes}>
      <div className="flex flex-1 items-center">
        <Popover
          placement="left"
          open={openPopOver}
          onOpenChange={(changed) => {
            setOpenPopOver(changed);
            if (changed) {
            }
          }}
        >
          <PopoverAnchor
            className="flex flex-1 p-2"
            onClick={(e) => {
              setOpenPopOver(!openPopOver);
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            <div
              className="w-[24px] h-[24px] rounded-full border"
              style={{
                backgroundColor: value ? value : "white",
                boxShadow: "inset 0 0 0 1px rgb(255 255 255 / 20%)",
              }}
            ></div>
            <div className="grigora-select-input__label ml-4 text-center flex items-center justify-between ">
              <span>{label}</span>
            </div>
          </PopoverAnchor>
          <PopoverContent className={contentClasses}>
            <div className="p-3">
              <GlobalSketchPicker value={value} onChange={onChange} />
            </div>
          </PopoverContent>
        </Popover>
      </div>
      <div className="px-2">
        <ResetState
          active={
            isResetVisible &&
            ((value !== resetValue && value != "") ||
              (valueTablet !== resetValueTablet && valueTablet != "") ||
              (valueMobile !== resetValueMobile && valueMobile != ""))
          }
          onClick={(e) => {
            onChange(resetValue);
            if (isResponsive) {
              // setActive("desktop");
              setValueTablet(resetValueTablet);
              setValueMobile(resetValueMobile);
            }
            e.preventDefault();
          }}
        />
      </div>
    </div>
  );
}

export default ColorInput;
